module.exports = __webpack_public_path__ + "static/media/dolce&gabbana-light-blue-big.9a573195.png";